import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BaseViewModel } from '../../ui-ndms/view-models/base.view-model';

@Injectable()
export class ViewModelService {
  private viewModelData: any = {};

  viewModelUpdated: {
    [key: string] : BehaviorSubject<any>
  } = {};

  getViewModel(key: string) {
    return (this.viewModelData[key] || {});
  }

  mergeViewModelData(key: string, src: any) {
    var dest = this.viewModelData[key];
    if (dest) {
      let srcKeys = Object.keys(src);
      let destKeys = Object.keys(dest);
      srcKeys.forEach( (srcKey) => {
        destKeys.forEach( (destKey) => {
          if (srcKey == destKey) {
            if (Array.isArray(src[srcKey])) {
              if (src[srcKey].length > 0) {
                dest[destKey] = src[srcKey];
              }
            } else {
              dest[destKey] = src[srcKey];
            }
          }
        });
      });

      this.loadViewModelData(key, dest);

      return dest;
    }
  }
  loadData(key: string, data: any){
    this.viewModelData[key] = data;
  }
  execute(key: string){
    if(!this.viewModelUpdated[key]) {
      this.viewModelUpdated[key] = new BehaviorSubject<any>(this.viewModelData[key]);
    }
    (this.viewModelUpdated[key] as BehaviorSubject<any>).next(this.viewModelData[key]);
  }
  setViewModel(key:string){
    if(!this.viewModelUpdated[key]) {
      this.viewModelUpdated[key] = new BehaviorSubject<any>(this.viewModelData[key]);
    }
  }
  loadViewModelData(key: string, data: any) {
    this.viewModelData[key] = data;

    if(!this.viewModelUpdated[key]) {
      this.viewModelUpdated[key] = new BehaviorSubject<any>(data);
    }
    
    (this.viewModelUpdated[key] as BehaviorSubject<any>).next(this.viewModelData[key]);
  }
}
